import React from "react";
import {
  FaInfoCircle,
  FaPhoneAlt,
  FaEnvelope,
  FaBuilding,
  FaMapMarkerAlt,
  FaLandmark
} from "react-icons/fa";
import "./ContactPage.css";

function ContactPage() {
  return (
    <div>

      {/* IMAGE BANNER */}
      <div
        className="contact-banner"
        style={{ backgroundImage: "url(/images/con_tact.jpeg)" }}
      >
      
      </div>

      <div className="contact-container">

        {/* HEADER */}
        <div className="contact-header">
          <h4 className="contact-small">CONTACT US</h4>
          <h1 className="contact-title-main">
 OUR EXPERTS ARE HAPPY TO HELP — JUST CONTACT US
          </h1>
        </div>

        {/* CONTACT DETAILS */}
        <div className="contact-details">

          <div className="contact-row">
            <div className="contact-icon">
              <FaInfoCircle />
            </div>
            <div className="contact-text">
              <p>
                <strong>Corporate Identity Number (CIN):   </strong>
                U65120TZ2026PTC038041
              </p>
            </div>
          </div>

          <div className="contact-row">
            <div className="contact-icon">
              <FaPhoneAlt />
            </div>
            <div className="contact-text">
              +91 7200039384
            </div>
          </div>

          <div className="contact-row">
            <div className="contact-icon">
              <FaEnvelope />
            </div>
            <div className="contact-text">
              hr@aerlis.in
            </div>
          </div>

        </div>

        {/* LOCATION TITLE */}
        <h2 className="location-title">Our Locations</h2>

        {/* ADDRESS CARD */}
        <div className="address-card">

          {/* CORPORATE OFFICE */}
          <div className="office-title">
            <FaBuilding className="office-icon" />
            Corporate Office
          </div>

          <p className="address-texts">
            AERLIS GRO IMF PVT LTD
          </p>

          <p className="address-texts">
            725-D, Avinashi Road,<br />
            S.R. Complex, Coimbatore - 641018
          </p>

          {/* GOOGLE MAP */}
          <div className="map-container">
            <iframe
              title="Office Location"
              className="map-iframe"
              src="https://www.google.com/maps?q=11.0088287,76.9798871&hl=en&z=17&output=embed"
              loading="lazy"
            ></iframe>
          </div>

          {/* GET DIRECTION BUTTON */}
          <div className="button-center">
            <a
              href="https://www.google.com/maps?q=11.0088287,76.9798871"
              target="_blank"
              rel="noreferrer"
              className="direction-btn"
            >
              <FaMapMarkerAlt /> Get Directions
            </a>
          </div>

          {/* REGISTERED OFFICE */}
          <div className="office-title">
            <FaLandmark className="office-icon" />
            Registered Office
          </div>

          <p className="address-texts">
            AERLIS GRO IMF PVT LTD
          </p>

          <p className="address-texts">
            725-D, Avinashi Road,<br />
            S.R. Complex, Coimbatore - 641018
          </p>

          {/* GOOGLE MAP */}
          <div className="map-container">
            <iframe
              title="Office Location"
              className="map-iframe"
              src="https://www.google.com/maps?q=11.0088287,76.9798871&hl=en&z=17&output=embed"
              loading="lazy"
            ></iframe>
          </div>

          {/* GET DIRECTION BUTTON */}
          <div className="button-center">
            <a
              href="https://www.google.com/maps?q=11.0088287,76.9798871"
              target="_blank"
              rel="noreferrer"
              className="direction-btn"
            >
              <FaMapMarkerAlt /> Get Directions
            </a>
          </div>

        </div>

      </div>
    </div>
  );
}

export default ContactPage;